/**
 * Route for `api-rate-limiting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ApiRateLimitingPage } from "../features/api-rate-limiting/ApiRateLimitingPage";

export const apiRateLimitingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/api-rate-limiting",
	component: ApiRateLimitingPage,
});

export default apiRateLimitingRoute;
